import { Ellipsis, Eye, Pencil, Trash2 } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

/**
 * Actions for the banner editor.
 *
 * @param {Function} onDelete - Callback function to handle delete.
 * @param {Function} toggleView - Callback function to toggle view.
 * @param {string} view - Current view.
 */
export default function BannerEditorActions({ onDelete, toggleView, view }) {
    const handleDelete = () => {
        // eslint-disable-next-line no-alert
        if (window.confirm('Are you sure you want to delete this content?')) {
            onDelete();
        }
    };

    return (
        <div className="flex items-center gap-2">
            <Button
                variant="ghost"
                size="icon"
                onClick={toggleView}
                aria-label={view === 'summary' ? 'Edit content' : 'View content summary'}
            >
                {view === 'summary' ? <Pencil /> : <Eye />}
            </Button>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="data-[state=open]:bg-muted"
                        aria-label="Content actions"
                    >
                        <Ellipsis />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem variant="destructive" onClick={handleDelete}>
                        <Trash2 className="mr-2 h-4 w-4" />
                        Delete
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
